import { FC, useEffect } from 'react';
import useBodyClass from "../../hooks/useBodyClass";

interface IProps {
    className: string | string[],
    [key: string]: any,
}

export const BodyClassName: FC<IProps> = ({className}) => {
    const { setClassName } = useBodyClass();

    useEffect(() => {
        if (className) {
            setClassName(className);
        }
    }, [className]);

    return null;
}